import { createSSRApp } from "vue";
import App from "./App.vue";
import '@/static/css/common.css'

export function createApp() {
  const app = createSSRApp(App);
  return {
    app,
  };
}
